import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersOpenFolderOnNoteAdd = createBasicSelector(
  state => selectBooleanPreferenceByName(state, 'open_folder_on_note_add')
)
